export default __webpack_public_path__ + "static/media/order_voucher.6a361cce.svg";